// extracted by mini-css-extract-plugin
export default {"game":"Pages_game__wFXVD","game_time":"Pages_game_time__jCr2N","game_btn":"Pages_game_btn__AaHhD"};